
export type MapEventType =
    'resize'        // Fired when the map is resized.
    | 'zoom'        // Fired repeatedly during any change in zoom level, including zoom and fly animations.
    | 'zoomstart'   // Fired when the map zoom is about to change (e.g. before zoom animation).
    | 'zoomend'     // Fired when the map has changed, after any animations.
    | 'move'        // Fired repeatedly during any movement of the map, including pan and fly animations.
    | 'movestart'   // Fired when the view of the map starts changing (e.g. user starts dragging the map).
    | 'moveend'     // Fired when the center of the map stops changing (e.g. user stopped dragging the map).
    | 'click'       // Fired when the user clicks (or taps) the map
    | 'mousedown'   // Fired when the user pushes the mouse button on the map.
    | 'mouseup'     // Fired when the user releases the mouse button on the map.
    | 'mousemove'   // Fired while the mouse moves over the map.
    | 'keypress'    // Fired when the user presses a key from the keyboard while the map is focused.
    | 'drag'
    | 'wheel'
    ;

export const mapTypeEventTypes: MapEventType[] = [
    'resize'
    , 'zoom'
    , 'zoomstart'
    , 'zoomend'
    , 'move'
    , 'movestart'
    , 'moveend'
    , 'click'
    , 'mousedown'
    , 'mouseup'
    , 'mousemove'
    , 'keypress'
    , 'drag'
    , 'wheel'
];
